import { useMarzipanoController } from '../context/MarzipanoControllerContext';
import { translate } from '../i18n';
import { useTourStore } from '../hooks/useTourStore';
import arrowDownIcon from '../assets/figma/ctrl-arrow-down.svg';
import arrowLeftIcon from '../assets/figma/ctrl-arrow-left.svg';
import zoomOutIcon from '../assets/figma/ctrl-zoom-out.svg';
import zoomInIcon from '../assets/figma/ctrl-zoom-in.svg';
import styles from './TourControls.module.css';

export function TourControls() {
  const locale = useTourStore((s) => s.locale);
  const controller = useMarzipanoController();

  const buttons = [
    { label: translate(locale, 'app.lookDown'), icon: arrowDownIcon, onClick: () => controller?.pan('down') },
    { label: translate(locale, 'app.lookUp'), icon: arrowDownIcon, flip: true, onClick: () => controller?.pan('up') },
    { label: translate(locale, 'app.lookLeft'), icon: arrowLeftIcon, onClick: () => controller?.pan('left') },
    { label: translate(locale, 'app.lookRight'), icon: arrowLeftIcon, flip: true, onClick: () => controller?.pan('right') },
    { label: translate(locale, 'app.zoomOut'), icon: zoomOutIcon, onClick: () => controller?.zoomOut() },
    { label: translate(locale, 'app.zoomIn'), icon: zoomInIcon, onClick: () => controller?.zoomIn() },
  ];

  return (
    <div className={styles.toolbar} role="toolbar" aria-label={translate(locale, 'app.viewControls')}>
      {buttons.map(({ label, icon, flip, onClick }) => (
        <button
          key={label}
          type="button"
          className={styles.btn}
          onClick={onClick}
          aria-label={label}
          title={label}
        >
          <img
            className={flip ? styles.flip : undefined}
            src={icon}
            width="36"
            height="36"
            alt=""
          />
        </button>
      ))}
    </div>
  );
}
